<template>
  <div class="wrapper">
    <el-button
      type="info"
      plain
      style="
        position: absolute;
        transform: translateX(-50%);
        top: 20vh;
        left: 50vw;
        z-index: 9999;
      "
      @click="handleHideLoading"
      v-show="isLoading"
      >取消加载</el-button
    >
    <top @clickButton="clickButton" @goHome="goHome"></top>
    <el-container>
      <nav-bar @addTab="addTab"></nav-bar>
      <el-main class="main">
        <div class="content" ref="content">
          <el-tabs
            v-model="editableTabsValue"
            type="card"
            closable
            @tab-remove="removeTab"
            @tab-click="clickTab"
          >
            <el-tab-pane
              v-for="(item, index) in editableTabs"
              :key="item.name"
              :label="item.title"
              :name="item.name"
            >
            </el-tab-pane>
          </el-tabs>
          <!--<router-view v-if="isRouterAlive"/>-->
          <div v-if="isRouterAlive">
            <keep-alive :include="topNavMentNames">
              <!--<router-view v-if='$route.meta.keepAlive'></router-view>-->
              <router-view></router-view>
            </keep-alive>
            <!--<router-view v-if='!$route.meta.keepAlive'></router-view>-->
          </div>
        </div>
      </el-main>
    </el-container>
    <form-dialog
      ref="formDialog"
      formDialogTitle="重置密码"
      :model="dialogModel"
      :dialogService="dialogService"
      :submitData="dialogData"
      :rules="dialogRules"
      @success="dialogSuccess"
      @close="dialogClose"
      @opend="dialogOpen"
      class="note"
    >
      <el-form-item label="密码" prop="passWord" style="margin-bottom: 40px">
        <el-input
          v-model="dialogModel.passWord"
          type="password"
          placeholder="请输入密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="重复密码" prop="rePassWord">
        <el-input
          v-model="dialogModel.rePassWord"
          type="password"
          placeholder="请输入重复密码"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import Top from "../fragment/Top";
import NavBar from "../fragment/NavBar";
import ElContainer from "element-ui/packages/container/src/main";
import FormDialog from "../dialog/FormDialog";
import store from "store";

import StorageService from "store/interfaces";
import PowerUserService from "service/PowerUserService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "index",
  components: {
    ElContainer,
    Top,
    NavBar,
    FormDialog,
  },
  provide() {
    return {
      reload: this.reload,
      handleScrollTop: this.handleScrollTop,
      addTab: this.addTab,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      editableTabsValue: "1",
      newEditableTabsValue: "1",
      routerIndex: "",
      newEditableTabs: [
        {
          title: "首页",
          name: "1",
          routerPath: "/index/welcome",
        },
      ],
      editableTabs: [
        {
          title: "首页",
          name: "1",
          routerPath: "/index/welcome",
        },
      ],
      tabIndex: 1,
      tabBarObj: {},
      dialogModel: {
        passWord: "",
        rePassWord: "",
      },
      dialogService: PowerUserService.modifypw,
      dialogRules: {
        passWord: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    "请输入6-20位密码，数字、字母、特殊字符至少两种以上组合"
                  )
                );
              } else {
                return value.match(
                  /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/
                )
                  ? callback()
                  : callback(
                      new Error(
                        "请输入6-20位密码，数字、字母、特殊字符至少两种以上组合"
                      )
                    );
              }
            },
          },
        ],
        rePassWord: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // console.log(value)
              if (!value) {
                callback(new Error("请输入重复密码"));
              } else if (value != this.dialogModel.passWord) {
                callback(new Error("两次密码输入不一致"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      // topNavMentNames:['welcome'],
    };
  },
  beforeRouteEnter(to, from, next) {
    if (
      typeof JSON.parse(JSON.stringify(store.getters.userToken)) != "string" ||
      JSON.parse(JSON.stringify(store.getters.userToken)) == null
    ) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    if (
      JSON.parse(JSON.stringify(this.tabBar)) != null &&
      JSON.parse(JSON.stringify(this.tabBar)) != {}
    ) {
      this.editableTabs = this.tabBar.editableTabs.slice();
      this.editableTabsValue = this.tabBar.editableTabsValue.slice();
      // this.topNavMentNames = this.alivePage.slice();
    }
  },
  computed: {
    dialogData() {
      const params = {
        id: this.userInfo ? this.userInfo.id : "",
        modifierId: this.userInfo ? this.userInfo.modifierId : "",
        passWord: this.dialogModel.passWord,
      };
      return params;
    },
    topNavMentNames() {
      if (
        JSON.parse(JSON.stringify(this.alivePage)) != null &&
        JSON.parse(JSON.stringify(this.tabBar)) != {}
      ) {
        return this.alivePage.slice();
      } else {
        return ["welcome"];
      }
    },
    ...mapGetters([
      "tabBar",
      "userToken",
      "userInfo",
      "alivePage",
      "isLoading",
    ]),
  },
  methods: {
    /**
     *  根据顶部筛选条件筛选-项目和时间段(存在vuex中)
     *  刷新当前显示的组件
     *  参考：https://juejin.im/entry/5b5ac53c5188251abb46c250
     * */
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    handleHideLoading() {
      this.hideLoading();
    },
    handleScrollTop() {
      this.$refs.content.scrollTop = 0;
    },
    addTab(targetName, routerPath) {
      let newTabName = ++this.tabIndex + "";
      this.editableTabs = this.tabBar.editableTabs.length
        ? this.tabBar.editableTabs.slice()
        : this.editableTabs;
      for (let i = 0; i < this.editableTabs.length; i++) {
        if (targetName == this.editableTabs[i].title) {
          this.editableTabsValue = this.editableTabs[i].name;

          this.tabBarObj.editableTabsValue = this.editableTabsValue;
          this.tabBarObj.editableTabs = this.editableTabs;
          this.setTabBar(this.tabBarObj);
          return;
        }
        if (newTabName == this.editableTabs[i].name) {
          newTabName = newTabName + 1;
        }
      }

      this.editableTabsValue = newTabName;
      this.editableTabs.push({
        title: targetName,
        name: newTabName,
        routerPath: routerPath,
      });
      const pageName = routerPath.substring(7, routerPath.length);
      this.topNavMentNames.push(pageName);
      this.tabBarObj.editableTabsValue = this.editableTabsValue;
      this.tabBarObj.editableTabs = this.editableTabs;
      this.handleSave(this.tabBarObj, this.topNavMentNames);
      // this.setAlivePage(this.topNavMentNames);
      // this.setTabBar(this.tabBarObj);
    },
    goHome() {
      this.$router.replace({
        name: "Index",
      });
      this.addTab("首页", "/index/welcome");
    },
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;

      if (targetName == 1) {
        return;
      }

      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);

      for (let i = 0; i < tabs.length; i++) {
        if (this.editableTabsValue == tabs[i].name) {
          this.$router.replace({
            // name:tabs[i].routerName
            path: tabs[i].routerPath,
          });
        }
        if (targetName == tabs[i].name) {
          const pageIndex = this.topNavMentNames.indexOf(
            tabs[i].routerPath.substring(7, tabs[i].routerPath.length)
          );
          this.topNavMentNames.splice(pageIndex, 1);
        }
      }

      this.tabBarObj.editableTabsValue = this.editableTabsValue;
      this.tabBarObj.editableTabs = this.editableTabs;
      // this.setTabBar(this.tabBarObj);
      // this.setAlivePage(this.topNavMentNames);
      this.handleSave(this.tabBarObj, this.topNavMentNames);

      if (this.tabBar.editableTabs.length == 1) {
        this.newEditableTabs = this.tabBar.editableTabs;
      }
    },
    handleSave(tab, alive) {
      this.setAlivePage(alive);
      this.setTabBar(tab);
    },
    clickTab(data) {
      let tabs = this.tabBar.editableTabs.slice();
      console.log(this.tabBar);
      let tabsName = data.label;
      tabs.forEach((tab, index) => {
        if (tab.title == tabsName) {
          this.$router.replace({
            // name:tab.routerName
            path: tab.routerPath,
          });
        }
      });

      this.tabBarObj.editableTabsValue = data.name;
      this.tabBarObj.editableTabs = tabs;
      this.setTabBar(this.tabBarObj);
    },
    clickButton() {
      this.$refs.formDialog.open();
    },
    dialogSuccess(res) {
      this.showSuccess(res.respMsg + ",请重新登录");
      this.$refs.formDialog.closeDialog();
      this.$router.replace({
        name: "Login",
      });
      this.setUser(null);
      this.setToken(null);
      this.setTabBar(null);
    },
    dialogClose() {},
    dialogOpen() {},
    ...mapActions({
      setTabBar: StorageService.TabBar.setTabBar,
      setUser: StorageService.User.setInfo,
      setToken: StorageService.User.setToken,
      setInnerTabBar: StorageService.TabBar.setInnerTabBar,
      setAlivePage: StorageService.AlivePage.setAlivePage,
    }),
  },
  watch: {
    $route(to, from) {
      if (to.path.indexOf("/index/memberbasicinfo") == "-1") {
        this.setInnerTabBar("basicinfo");
      }
    },
    newEditableTabs(val) {
      this.editableTabs = this.tabBar.editableTabs;
      this.editableTabsValue = this.tabBar.editableTabsValue;
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1px 3px;
  width: 100%;
}

.main {
  flex: 1;
  background: #f9f9f9;
  overflow: hidden;
  position: relative;
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/page/Index.vue